import Alpine from 'alpinejs';

Alpine.store('share', {
    type: null, // 'wishlist' or 'property'
    shareUrl: '',
    copied: false,
    title: '',
    emailMode: false,
    recipientEmail: '',
    isSending: false,
    emailSuccess: false,
    emailError: '',

    // Wishlist-specific
    mosaicHtml: '',
    quantity: 0,
    listingIds: [],

    // Property-specific
    image: '',
    subtitle: '',

    openWishlist(uid) {
        this.type = 'wishlist';
        this.copied = false;
        this.emailMode = false;
        this.recipientEmail = '';
        this.isSending = false;
        this.emailSuccess = false;
        this.emailError = '';

        const baseUrl = window.location.origin;
        this.shareUrl = `${baseUrl}/wishlist/${uid}`;

        // Get the mosaic HTML and metadata from the hidden element
        const mosaicEl = document.querySelector(`[data-wishlist-mosaic="${uid}"]`);
        this.mosaicHtml = mosaicEl ? mosaicEl.innerHTML : '';
        this.title = mosaicEl?.getAttribute('data-wishlist-title') || '';
        this.quantity = parseInt(mosaicEl?.getAttribute('data-wishlist-quantity') || '0', 10);

        const rawIds = mosaicEl?.getAttribute('data-wishlist-ids') || '';
        this.listingIds = rawIds ? rawIds.split(',').map(id => parseInt(id, 10)) : [];

        Alpine.store('modals')?.open('share-modal');
    },

    openProperty({ title, image, url, subtitle }) {
        this.type = 'property';
        this.copied = false;
        this.emailMode = false;
        this.recipientEmail = '';
        this.isSending = false;
        this.emailSuccess = false;
        this.emailError = '';
        this.title = title || '';
        this.image = image || '';
        this.subtitle = subtitle || '';
        const raw = url || window.location.href;
        this.shareUrl = raw.split('?')[0];

        Alpine.store('modals')?.open('share-modal');
    },

    close() {
        this.type = null;
        this.emailMode = false;
        this.recipientEmail = '';
        this.isSending = false;
        this.emailSuccess = false;
        this.emailError = '';
        Alpine.store('modals')?.close('share-modal');
    },

    get emailSubject() {
        if (this.type === 'wishlist') {
            return 'Check out my Avari collection';
        }
        return `Check out ${this.title || 'this property'} on Avari`;
    },

    get emailBody() {
        if (this.type === 'wishlist') {
            return `I wanted to share my collection with you: ${this.shareUrl}`;
        }
        return `I thought you might like this: ${this.shareUrl}`;
    },

    async copyLink() {
        try {
            await navigator.clipboard.writeText(this.shareUrl);
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
            const input = document.getElementById('share-url-input');
            if (input) {
                input.select();
                document.execCommand('copy');
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
            }
        }
    },

    async sendWishlistEmail() {
        if (this.type !== 'wishlist') {
            return;
        }

        const rawEmail = (this.recipientEmail || '').trim();
        if (!rawEmail) {
            this.emailError = 'Recipient email is required.';
            return;
        }

        const csrf = window.__csrfToken;
        if (!csrf || !csrf.name || !csrf.value) {
            this.emailError = 'CSRF token not available. Please refresh and try again.';
            return;
        }

        this.isSending = true;
        this.emailError = '';

        try {
            const formData = new FormData();
            formData.append('recipientEmail', rawEmail);
            formData.append('wishlistName', this.title || 'Shared Wishlist');
            this.listingIds.forEach((id) => formData.append('listingIds[]', String(id)));
            formData.append(csrf.name, csrf.value);

            const response = await fetch('/actions/avari/wishlist/share', {
                method: 'POST',
                body: formData,
                headers: {
                    Accept: 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            const data = await response.json();
            if (!response.ok || !data?.success) {
                this.emailError = data?.error || data?.message || 'Failed to share wishlist.';
                return;
            }

            this.emailSuccess = true;
            this.emailMode = false;
            this.recipientEmail = '';
        } catch (err) {
            this.emailError = 'An unexpected error occurred while sharing.';
            console.error(err);
        } finally {
            this.isSending = false;
        }
    }
});
